import { cn } from '@/lib/utils';

import type { WeeklyCalendarLabels } from './types';
import { isSameDay } from './utils';

interface DayHeaderProps {
  date: Date;
  labels: WeeklyCalendarLabels;
  isToday: boolean;
}

export function DayHeader({ date, labels, isToday }: DayHeaderProps) {
  const dayName = labels.dayNames[(date.getDay() + 6) % 7];
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-2 py-2 select-none',
        'border-r border-biz-border last:border-r-0',
        isToday && 'bg-biz-primary-subtle/40',
      )}
      aria-current={isToday ? 'date' : undefined}
    >
      <div
        className={cn(
          'text-[11px] font-semibold uppercase tracking-wider',
          isToday ? 'text-biz-primary-subtle-fg' : 'text-biz-foreground-muted',
        )}
      >
        {dayName}
      </div>
      <div
        className={cn(
          'font-mono-num text-lg font-semibold mt-0.5',
          isToday ? 'text-biz-primary-subtle-fg' : 'text-biz-foreground',
        )}
      >
        {date.getDate().toString().padStart(2, '0')}
      </div>
      {isToday && (
        <div className="mt-1 h-0.5 w-8 rounded-full bg-biz-primary" aria-hidden />
      )}
    </div>
  );
}

DayHeader.isToday = (d: Date) => isSameDay(d, new Date());
